'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import type { SurveyRecord } from '@/types/survey';

const BarChartClient = dynamic(() => import('./BarChartClient'), { ssr: false });

interface StatusDistributionChartProps {
  records: SurveyRecord[];
}

export default function StatusDistributionChart({ records }: StatusDistributionChartProps) {
  const completeCount = records.filter((r) => r.status === 'complete').length;
  const terminateCount = records.filter((r) => r.status === 'terminate').length;
  const qualityCount = records.filter((r) => r.status === 'qualitySecurity').length;
  const quotaCount = records.filter((r) => r.status === 'quotaFull').length;

  const data = [
    { name: 'Complete', value: completeCount, fill: '#22c55e' },
    { name: 'Terminate', value: terminateCount, fill: '#ef4444' },
    { name: 'Qual/Sec', value: qualityCount, fill: '#9333ea' },
    { name: 'Quota Full', value: quotaCount, fill: '#f59e0b' },
  ];

  return (
    <div className="glass-card rounded-xl border border-border p-5 fade-in-up fade-in-delay-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-foreground">Status Distribution</h3>
        <span className="text-xs text-muted-foreground">All time</span>
      </div>
      <BarChartClient data={data} />
    </div>
  );
}